module.exports = __webpack_public_path__ + "img/panama.ffbdadba.png";